import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Form, TextArea,Popup } from 'semantic-ui-react';
import "../../styles/RetrievalParameter.css";
import "../../uiComponents/Slider/SliderComponent.css";
import "../../uiComponents/NumberInputBox/NumberInput.css";
import '../../uiComponents/TextField/TextFieldComponent.css';
import "../../uiComponents/Dropdown/DropdownComponent.css";
import "../../uiComponents/Radio/RadioButton.css";
import "../../styles/MCPToolsManager.css";
import Box from '@mui/material/Box';
import { updatePrompt, createPrompt, fetchDataSetParameters, getParametersSuccess } from '../../actions/dataConsoleAction';
import { useLocation } from 'react-router-dom';
import CustomToaster from "../../components/CustomToaster";
import PromptLoader from "../../components/PromptLoader";
import SliderComponent from '../../uiComponents/Slider/SliderComponent';
import NumberInput from '../../uiComponents/NumberInputBox/NumberInput';
import TextfieldComponent from '../../uiComponents/TextField/TextfieldComponent';
import DropdownComponent from '../../uiComponents/Dropdown/DropdownComponent';
import RadioButton from '../../uiComponents/Radio/RadioButton'
import ToggleButtonGroup from '../../uiComponents/ToggleButtonGroup/ToggleButtonGroup';
import MCPToolsManager from './MCPToolsManager';
import { set } from 'date-fns';
import modelsConfig from '../../config/models.json';

const MAX_KVALUE = 16;
const MIN_KVALUE = 1;

const MAX_THRESHOLD = 1;
const MIN_THRESHOLD = 0;

const MAX_TEMP = 1;
const MIN_TEMP = 0;

const MAX_TOKEN = 4096;
const MIN_TOKEN = 1;

const MAX_TOP_P = 1;
const MIN_TOP_P = 0;

const getLoaderType = (location) => {
  if (location.pathname.includes('aiassistant')) {
    return 'aiassistent';
  } else if (location.pathname.includes('dataset')) {
    return 'dataconsole';
  }
  return 'default'; // Fallback or default loader type
};

const RetrievalParameter = ({ onSave, datasetId: propDatasetId, saveParams, params, onParamsChange, userType}) => {
  // Map state from Redux store to local variables
  const { parameters, loading, error } = useSelector((state) => state.parameters || { parameters: {}, loading: false, error: null });
  // Initialize state for form fields
  const [prompt, setPrompt] = useState(process.env.REACT_APP_DEFAULT_PROMPT || ' ');
  const [kValue, setKValue] = useState(process.env.REACT_APP_DEFAULT_K_VALUE || 8);
  const [thresholdValue, setThreshold] = useState(process.env.REACT_APP_DEFAULT_THRESHOLD || 0.4);
  const [enableReRanker, setEnableReRanker] = useState(process.env.REACT_APP_DEFAULT_ENABLE_RERANKER || false);
  const [temperature, setTemperature] = useState(process.env.REACT_APP_DEFAULT_TEMPERATURE || 0.1);
  const [modelName, setModelName] = useState(process.env.REACT_APP_DEFAULT_MODEL_NAME || modelsConfig.defaultModel);
  const [maxTokens, setMaxTokens] = useState(process.env.REACT_APP_DEFAULT_MAX_TOKENS || 1024);
  const [questionGeneratorPrompt, setQuestionPrompt] = useState(process.env.REACT_APP_DEFAULT_QUESTION_PROMPT || ' ');
  const [clarifyPrompt, setClarifyPrompt] = useState(process.env.REACT_APP_DEFAULT_CLARIFY_PROMPT || ' ');
  const [isClarifyPromptEnabled, setIsClarifyPromptEnabled] = useState(true);
  const [regeneratePrompt, setRegenerationPrompt] = useState(process.env.REACT_APP_DEFAULT_REGENERATE_PROMPT || '');
  const [regenerateWithFeedbackPrompt, setRegenerationFeedbackPrompt] = useState(process.env.REACT_APP_DEFAULT_REGENERATE_WITH_FEEDBACK_PROMPT || '');
  const [topPValue, setTopPValue] = useState(process.env.REACT_APP_DEFAULT_TOP_P_VALUE || 0.5);
  const [responseFormat, setResponseFormat] = useState(process.env.REACT_APP_DEFAULT_RESPONSE_FORMAT || 'Text');
  const [retrievalStrategy, setRetrievalStrategy] = useState(process.env.REACT_APP_DEFAULT_RETRIEVAL_STRATEGY || 'Semantic');
  const [isRerankerEnabled, setIsRerankerEnabled] = useState(process.env.REACT_APP_DEFAULT_ENABLE_RERANKER || false);
  const [showImagesOption, setShowImagesOption] = useState(process.env.REACT_APP_DEFAULT_SHOW_IMAGES_OPTION || 'fullPages');
  const [showSource, setShowSource] = useState(process.env.REACT_APP_DEFAULT_SHOW_SOURCE !== 'false');
  const [tableSchema, setTableSchema] = useState('');
  const [isSaved, setIsSaved] = useState(false);
  const dispatch = useDispatch();
  const location = useLocation();
  let datasetId = propDatasetId;
  const [saveDisabled, setSaveDisabled] = useState(true);
  const [toasterVisible, setToasterVisible] = useState(false);
  const [toasterMessage, setToasterMessage] = useState("");
  const [toasterAppearance, setToasterAppearance] = useState("success");
  const [localParams, setLocalParams] = useState(params);
  const [retrievalParams, setRetrievalParams] = useState(params);
  const [isloading, setIsLoading] = useState(false);
  const isMounted = useRef(true);
  const [documentId, setDocumentId] = useState(null); // State to store the _id
  const [isSaving, setIsSaving] = useState(false); // State to track loading for save button
  const [shouldResetForm, setShouldResetForm] = useState(true);
  const [isReadOnlyState, setIsReadOnlyState] = useState(false); // Define isReadOnlyState
  const [agenticQnAEnabled, setAgenticQnAEnabled] = useState(false); // New state
  const [agentPrompt, setAgentPrompt] = useState(process.env.REACT_APP_DEFAULT_AGENT_PROMPT || ''); // 1. Add agentPrompt state
  const [mcpTools, setMcpTools] = useState([]); // MCP Tools state
  const [selectedMcpTools, setSelectedMcpTools] = useState([]); // Selected MCP Tools for agent to use

  useEffect(() => {
      if (userType === 'DatasetAdmin') {
        setIsReadOnlyState(true);
      }
    }, [userType]);

  useEffect(() => {
    if (!propDatasetId) {
      const urlParams = new URLSearchParams(location.search);
      datasetId = urlParams.get("c");
    }
  }, [propDatasetId, location]);

  const handleSetPrompt = (value) => {
    if (value.trim() === '') {
      setPrompt(' '); // Revert to a space if the value is empty
    } else {
      setPrompt(value);
    }
  };

  const handleToggleChange = () => {
   
    // if (isClarifyPromptEnabled) {
    //       // Currently enabled; when disabling, clear the text field.
    //       setClarifyPrompt(' ');
    //     } else {
    //       // Currently disabled; when enabling, load the default clarify prompt.
    //       setClarifyPrompt(process.env.REACT_APP_DFAULT_CLARIFY_PROMPT || ' ');
    //     }
        setIsClarifyPromptEnabled(!isClarifyPromptEnabled);
  
  };

  useEffect(() => {
    // Reset to default values when datasetId changes
    setRetrievalParams(params[datasetId] || resetFormFields);
  }, [datasetId, params]);

  useEffect(() => {
    const paramsArray = {
      prompt,
      kValue,
      thresholdValue,
      enableReRanker,
      isRerankerEnabled,
      showImagesOption,
      showSource,
      temperature,
      modelName,
      maxTokens,
      regeneratePrompt,
      regenerateWithFeedbackPrompt,
      questionGeneratorPrompt,
      clarifyPrompt,
      isClarifyPromptEnabled,
      topPValue,
      responseFormat,
      retrievalStrategy,
      tableSchema,
      agenticQnAEnabled,
      agentPrompt, // 3. In useEffect for onParamsChange, add agentPrompt
      mcpTools, // MCP Tools configuration
      selectedMcpTools, // Selected MCP Tools for agent
    };

    if (typeof onParamsChange === 'function') {
      onParamsChange(paramsArray);
    } else {
      console.error('onParamsChange is not a function');
    }
  }, [
    prompt,
    kValue,
    thresholdValue,
    enableReRanker,
    isRerankerEnabled,
    showImagesOption,
    showSource,
    temperature,
    modelName,
    maxTokens,
    regeneratePrompt,
    regenerateWithFeedbackPrompt,
    questionGeneratorPrompt,
    clarifyPrompt,
    isClarifyPromptEnabled,
    topPValue,
    responseFormat,
    retrievalStrategy,
    mcpTools,
    selectedMcpTools,
    tableSchema,
    agenticQnAEnabled,
    agentPrompt, // 3. In useEffect for onParamsChange, add agentPrompt
  ]);


  const showToaster = (message, appearance) => {
    setToasterVisible(true);
    setToasterMessage(message);
    setToasterAppearance(appearance);
  };

  const closeToaster = () => {
    setToasterVisible(false);
  };


  // Utility function to get the appropriate class name based on the URL
  const getClassName = (baseClass, location) => {
    if (location.pathname.includes('aiassistant')) {
      return ` aiassistant-${baseClass}`;
    } else if (location.pathname.includes('dataset')) {
      return `dataset-${baseClass}`;
    }
    return baseClass;
  };

  // Function to reset form fields to default values
  const resetFormFields = () => {
    setPrompt(process.env.REACT_APP_DEFAULT_PROMPT || ' ');
    setKValue(process.env.REACT_APP_DEFAULT_K_VALUE || 8);
    setThreshold(process.env.REACT_APP_DEFAULT_THRESHOLD || 0.4);
    setTemperature(process.env.REACT_APP_DEFAULT_TEMPERATURE || 0.1);
    setModelName(process.env.REACT_APP_DEFAULT_MODEL_NAME || modelsConfig.defaultModel);
    setMaxTokens(process.env.REACT_APP_DEFAULT_MAX_TOKENS || 1024);
    setQuestionPrompt(process.env.REACT_APP_DEFAULT_QUESTION_PROMPT || ' ');
    setAgentPrompt(process.env.REACT_APP_DEFAULT_AGENT_PROMPT || ' ');
    setClarifyPrompt(process.env.REACT_APP_DEFAULT_CLARIFY_PROMPT || ' ');
    setIsClarifyPromptEnabled(false);
    setTopPValue(process.env.REACT_APP_DEFAULT_TOP_P_VALUE || 0.5);
    setRetrievalStrategy(process.env.REACT_APP_DEFAULT_RETRIEVAL_STRETEGY || 'Semantic');
    setRegenerationPrompt(process.env.REACT_APP_DEFAULT_REGENERATE_PROMPT || ' ');
    const RerankerEnabled = process.env.REACT_APP_DEFAULT_ENABLE_RERANKER !== undefined && process.env.REACT_APP_DEFAULT_ENABLE_RERANKER !== ''
      ? process.env.REACT_APP_DEFAULT_ENABLE_RERANKER.toLowerCase() === 'true'
      : true; // Default value set to true
    setIsRerankerEnabled(RerankerEnabled);
    setShowImagesOption(process.env.REACT_APP_DEFAULT_SHOW_IMAGES_OPTION || 'fullPages');
    setShowSource(process.env.REACT_APP_DEFAULT_SHOW_SOURCE !== 'false');
    setTableSchema('');
    setMcpTools([]); // Reset MCP Tools
    setSelectedMcpTools([]); // Reset selected MCP Tools
    // Auto-enable Agent Instruction for standard quick chat mode
    const urlParams = new URLSearchParams(window.location.search);
    const quickChatParam = urlParams.get("quickChat");
    const methodParam = urlParams.get("method");
    const isStandardQuickChat = quickChatParam === "1" && methodParam === "quickChat";
    
    setAgenticQnAEnabled(isStandardQuickChat ? true : false); // Auto-enable for standard quick chat
    };

  const fetchPrompt = async (datasetId) => {
    setIsLoading(true); // Set loading to true before fetching data
    try {
      const response = await dispatch(fetchDataSetParameters(datasetId));
      console.log("response", response);
      if (response && response._id) {
        setDocumentId(response._id); // Store the _id in the state
        setShouldResetForm(false); // Do not reset form fields
      } else {
        setShouldResetForm(true); // Reset form fields if no _id is received
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setShouldResetForm(true); // Reset form fields in case of error
      console.log("Error fetching data:", error);
    } finally {
      setIsLoading(false); // Set loading to false after data is fetched or if there's an error
    }
  };

  useEffect(() => {
    if (isMounted.current) {
      fetchPrompt(datasetId);
      isMounted.current = false;
      dispatch(getParametersSuccess([]));
    } else {
      fetchPrompt(datasetId);
    }
  }, [datasetId, dispatch]);


  useEffect(() => {
    if (parameters && parameters.success === false && parameters.message.includes('No prompt found')) {
      if (shouldResetForm) {
        console.log('No prompt found, resetting fields.');
        resetFormFields();
      }
    } else if (parameters && parameters.prompt) {
      handleSetPrompt(parameters.prompt || ' ');
      setKValue(parameters.kValue);
      setThreshold(parameters.thresholdValue);
      setTemperature(parameters.temperature);
      setModelName(parameters.modelName || '');
      setMaxTokens(parameters.maxTokens);
      setQuestionPrompt(parameters.questionGeneratorPrompt || '');
      setClarifyPrompt(parameters.clarifyPrompt || '');
      setAgentPrompt(parameters.agentPrompt || '');
      setIsClarifyPromptEnabled(parameters.isClarifyPromptEnabled || false);
      setRegenerationPrompt(parameters.regeneratePrompt || '');
      setRegenerationFeedbackPrompt(parameters.regenerateWithFeedbackPrompt || '');
      setTopPValue(parameters.topPValue);
      setResponseFormat(parameters.responseFormat || '');
      setRetrievalStrategy(parameters.retrievalStrategy || '');
      setIsRerankerEnabled(parameters.enableReRanker || false);
      setShowImagesOption(parameters.showImagesOption || 'fullPages');
      setShowSource(parameters.showSource !== false);
      setTableSchema(parameters.tableSchema || '');
      // MCP Tools configuration
      setMcpTools(parameters.mcpTools || []);
      setSelectedMcpTools(parameters.selectedMcpTools || (parameters.mcpTools ? parameters.mcpTools.map(t => t.toolId || t.id) : []));
      // Auto-enable Agent Instruction for standard quick chat mode
      const urlParams = new URLSearchParams(window.location.search);
      const quickChatParam = urlParams.get("quickChat");
      const methodParam = urlParams.get("method");
      const isStandardQuickChat = quickChatParam === "1" && methodParam === "quickChat";
      
      setAgenticQnAEnabled(isStandardQuickChat ? true : (parameters.agenticQnAEnabled || false));
      setAgentPrompt(parameters.agentPrompt || ''); // 2. In useEffect for loading parameters from backend, set agentPrompt
    } else if (!parameters || Object.keys(parameters).length === 0) {
      if (shouldResetForm) {
        console.log('No parameters found, resetting fields.');
        resetFormFields();
      }
    }
    // Reset the flag after handling
  }, [parameters, shouldResetForm]);

  // Helper function to compare MCP tools arrays
  const areMcpToolsEqual = (tools1, tools2) => {
    if (!tools1 && !tools2) return true;
    if (!tools1 || !tools2) return false;
    if (tools1.length !== tools2.length) return false;
    return JSON.stringify(tools1) === JSON.stringify(tools2);
  };

  // Compare form data with initial parameters to enable/disable the save button
  useEffect(() => {
    const isChanged = (
      prompt !== parameters.prompt ||
      kValue !== parameters.kValue ||
      thresholdValue !== parameters.thresholdValue ||
      temperature !== parameters.temperature ||
      modelName !== parameters.modelName ||
      maxTokens !== parameters.maxTokens ||
      regeneratePrompt !== parameters.regeneratePrompt ||
      questionGeneratorPrompt !== parameters.questionGeneratorPrompt ||
      clarifyPrompt !== parameters.clarifyPrompt ||
      isClarifyPromptEnabled !== parameters.isClarifyPromptEnabled ||
      topPValue !== parameters.topPValue ||
      retrievalStrategy !== parameters.retrievalStrategy ||
      isRerankerEnabled !== parameters.enableReRanker ||
      showImagesOption !== parameters.showImagesOption ||
      showSource !== parameters.showSource ||
      regenerateWithFeedbackPrompt !== parameters.regenerateWithFeedbackPrompt ||
      tableSchema !== parameters.tableSchema ||
      agenticQnAEnabled !== parameters.agenticQnAEnabled ||
      agentPrompt !== parameters.agentPrompt ||
      !areMcpToolsEqual(mcpTools, parameters.mcpTools) ||
      !areMcpToolsEqual(selectedMcpTools, parameters.selectedMcpTools)
    );

    setSaveDisabled(!isChanged);
  }, [
    prompt, kValue, thresholdValue, temperature, modelName, maxTokens, regeneratePrompt,
    regenerateWithFeedbackPrompt, questionGeneratorPrompt, clarifyPrompt, isClarifyPromptEnabled,
    topPValue, retrievalStrategy, isRerankerEnabled, showImagesOption, showSource, tableSchema, parameters,
    agenticQnAEnabled, agentPrompt, mcpTools, selectedMcpTools
  ]);

  // Handle MCP tools change
  const handleMcpToolsChange = (tools, selected) => {
    setMcpTools(tools);
    setSelectedMcpTools(selected);
  };

  const handleSave = async () => {
    try {
      setIsLoading(true);
      const payload = {
        prompt,
        kValue,
        thresholdValue,
        enableReRanker: isRerankerEnabled,
        temperature,
        modelName,
        maxTokens,
        regeneratePrompt,
        regenerateWithFeedbackPrompt,
        questionGeneratorPrompt,
        topPValue,
        showImagesOption,
        showSource,
        clarifyPrompt,
        isClarifyPromptEnabled,
        tableSchema,
        agenticQnAEnabled,
        agentPrompt,
        mcpTools, // MCP Tools configuration
        selectedMcpTools, // Selected MCP Tools for agent to use
      };

      if (parameters && parameters._id) {
        await dispatch(updatePrompt(payload, datasetId, parameters._id));
        setToasterMessage("Prompt updated successfully");
        setToasterAppearance("success");
      } else {
        await dispatch(createPrompt(payload, datasetId));
        setToasterMessage("Prompt created successfully");
        setToasterAppearance("success");
      }   
  
  dispatch(fetchDataSetParameters(datasetId));
  setIsLoading(false); // Set loading to false after data is fetched or if there's an error

} catch (error) {
  console.error('Error saving prompt:', error);
  showToaster('An error occurred while saving the prompt.', 'error');
  setIsSaved(false);
  }
};

  const handleClarifyPromptChange = (event) => {
    // Safely handle the event and ensure the value is properly retrieved
    const { value } = event.target || {};
    if (isClarifyPromptEnabled && value !== undefined) {
      setClarifyPrompt(value);
    }
  };

  useEffect(() => {
    if (isMounted.current) {
      fetchDataSetParameters();
      isMounted.current = false;
      dispatch(getParametersSuccess([]));
    }
  }, []);

  const handleClear = () => {
      resetFormFields();
      setIsSaved(false);
  };

  const handleRerankerChange = (e, { value }) => {
    setIsRerankerEnabled(value === 'yes');
  };

  const handleShowSourceChange = (e, { value }) => {
    setShowSource(value === 'yes');
  };

  const handleShowImagesOption = (e, { value }) => {
    setShowImagesOption(value);
  };

  return (
    <div data-cy="retrieval-section" className={getClassName('retrieval-parameter', location)}>
      {toasterVisible && (
        <CustomToaster
          message={toasterMessage}
          duration={2000}
          onClose={closeToaster}
          position="right-top"
          appearance={toasterAppearance}
        />
      )}

      {isloading && (

        <div style={{ position: "relative", height: "100vh" }} className={getClassName('prompt-loader', location)}>
          <PromptLoader loaderType={getLoaderType(location)} />
        </div> // Show loader if data is being fetched
      )}

      {!isloading && (
        <Form className={getClassName('form-container', location)}>
          <Form.Field className={getClassName('prompt-container', location)}>
            <Popup
              content={"The prompt used for generating Q&A responses."}
              inverted
              position="top left"
              style={{ borderRadius: "15px" }}
              trigger={<label className={getClassName('prompt-label', location)}>QnA Prompt</label>}
            />
            <TextfieldComponent
              rows="7"
              className={getClassName('textfield-input', location)}
              dataCy="prompt-input-field"
              value={prompt}
              onChange={handleSetPrompt}
              onKeyPress={(e) => {
                if (e.key === '{' || e.key === '}' || e.key === '"') {
                  e.preventDefault();
                }
              }}
              disabled={isReadOnlyState}
            />
          </Form.Field>

          {/* Hide Agent Instruction for Assistant Quick Chat */}
          {(() => {
            const urlParams = new URLSearchParams(window.location.search);
            const quickChatParam = urlParams.get("quickChat");
            const methodParam = urlParams.get("method");
            const isAssistantQuickChat = quickChatParam === "1" && methodParam === "assistantQuickChat";
            
            return !isAssistantQuickChat && (
              <Form.Field className={getClassName('prompt-container', location)}>
                <div className='prompt-label-container' style={{ marginBottom: "0.5em"}}>
                  <Popup
                    content={"The prompt used for generating Agent responses."}
                    inverted
                    position="top left"
                    style={{ borderRadius: "15px", background: "black", color: "white", padding: "0.5rem" }}
                    trigger={<label className={getClassName('prompt-label', location)}>Agent Instruction</label>}
                  />
                  {/* Toggle for enabling/disabling Agent Instruction */}
                  <Popup
                    content={agenticQnAEnabled ? "Disable Agent Instruction" : "Enable Agent Instruction"}
                    inverted
                    position="top center"
                    style={{ borderRadius: "15px", background: "black", color: "white", padding: "0.5rem" }}
                    trigger={
                      <label className="toggle-label" >
                        <input
                          type="checkbox"
                          checked={agenticQnAEnabled}
                          onChange={() => {
                            setAgenticQnAEnabled((prev) => !prev);
                          }}
                          className="toggle-input"
                        />
                        <span className="toggle-slider"></span>
                      </label>
                    }
                  />
                </div>
                <TextfieldComponent
                  rows="7"
                  className={getClassName('textfield-input', location)}
                  dataCy="agent-prompt-input-field"
                  value={agentPrompt}
                  onChange={setAgentPrompt}
                  // Allow curly braces, block only double quotes
                  onKeyPress={(e) => {
                    if (e.key === '"') {
                      e.preventDefault();
                    }
                  }}
                  disabled={!agenticQnAEnabled}
                />
                
                {/* MCP Tools Manager - Only shown when Agentic Instruction is enabled */}
                <MCPToolsManager
                  mcpTools={mcpTools}
                  onToolsChange={handleMcpToolsChange}
                  isEnabled={agenticQnAEnabled}
                  isReadOnly={isReadOnlyState}
                  datasetId={datasetId}
                  getClassName={getClassName}
                  location={location}
                />
              </Form.Field>
            );
          })()}

          {/* Show Agentic QnA toggle only for aiassistant */}
          {/* {getClassName('prompt-container', location).includes('aiassistant') && (
            <Form.Field className={getClassName('agenticqna-container', location)} style={{ marginTop: "1.8em", marginBottom: "-0.5em" }}>
              <Popup
                content="Enable or disable Agentic QnA. When enabled, the system will use agentic reasoning for QnA."
                inverted
                position="top left"
                style={{ borderRadius: "15px" }}
                trigger={<label className={getClassName('prompt-label', location)}>Agentic QnA</label>}
                disabled={isReadOnlyState}
              />
              <ToggleButtonGroup
                isSimpleToggle
                isEnabled={agenticQnAEnabled}
                onToggle={() => setAgenticQnAEnabled((prev) => !prev)}
                isReadOnly={isReadOnlyState}
                className="agenticqna-toggle"
                dataCy="agenticqna-toggle"
                disabled={isReadOnlyState}
              />
              
            </Form.Field>
          )} */}

          <div className={getClassName('pair-K-threshold', location)}>
            {/* K Value Slider */}
            <Form.Field className={getClassName('kvalue-container', location)} data-cy="kvalue-container-section">
              {/* <label className={getClassName('kvalue-label', location)}>K Value</label> */}
              <Popup
               content={"Count of max source documents that can be used to arrive at response."}
               inverted
               position="top left"
               style={{ borderRadius: "15px" }}
               trigger={<label className={getClassName('kvalue-label', location)}>K Value</label>}
               disabled={isReadOnlyState}
              />
              <Box className={getClassName('slider', location)}>
                <SliderComponent
                  value={kValue}
                  min={MIN_KVALUE}
                  max={MAX_KVALUE}
                  step={1}
                  onChange={(e, newValue) => setKValue(newValue)}
                  location={location}
                  marks={[{ value: MIN_KVALUE }, { value: MAX_KVALUE }]}
                  disabled={isReadOnlyState}
                />
                <NumberInput
                  value={kValue}
                  min={MIN_KVALUE}
                  max={MAX_KVALUE}
                  step={1}
                  onChange={(value) => setKValue(value)}
                  location={location}
                  className={getClassName('output-box', location)}
                  dataCy="kvalue-output-box"
                  disabled={isReadOnlyState}
                />

              </Box>
            </Form.Field>

            {/* Threshold Slider */}
            <Form.Field className={getClassName('threshold-container', location)}>
              {/* <label className={getClassName('threshold-label', location)}>Threshold Value</label> */}
              <Popup
               content={"The minimum % that the source documents needs to match with the question."}
               inverted
               position="top left"
               style={{ borderRadius: "15px" }}
               trigger={<label className={getClassName('threshold-label', location)}>Threshold Value</label>}
               disabled={isReadOnlyState}
              />
              <Box className={getClassName('slider', location)}>
                <SliderComponent
                  value={thresholdValue}
                  min={MIN_THRESHOLD}
                  max={MAX_THRESHOLD}
                  step={0.01}
                  onChange={(e, newValue) => setThreshold(newValue)}
                  marks={[{ value: MIN_THRESHOLD }, { value: MAX_THRESHOLD }]}
                  disabled={isReadOnlyState}
                />
                <NumberInput
                  value={thresholdValue}
                  min={MIN_THRESHOLD}
                  max={MAX_THRESHOLD}
                  step={0.01}
                  onChange={(value) => setThreshold(value)}
                  className={getClassName('output-box', location)}
                  dataCy="threshold-output-box"
                  disabled={isReadOnlyState}
                />

              </Box>
            </Form.Field>
          </div>

          <div className={getClassName('pair-temp-token', location)}>
            {/* Temperature Slider */}
            <Form.Field className={getClassName('temperature-container', location)}>
              {/* <label className={getClassName('temperature-label', location)}>Temperature</label> */}
              <Popup
               content={"% allowed for the model to consider outside world information."}
               inverted
               position="top left"
               style={{ borderRadius: "15px" }}
               trigger={<label className={getClassName('temperature-label', location)}>Temperature</label>}
               disabled={isReadOnlyState}
             />
              <Box className={getClassName('slider', location)}>
                <SliderComponent
                  value={temperature}
                  min={MIN_TEMP}
                  max={MAX_TEMP}
                  step={0.01}
                  onChange={(e, newValue) => setTemperature(newValue)}
                  marks={[{ value: MIN_TEMP }, { value: MAX_TEMP }]}
                  disabled={isReadOnlyState}
               />
                <NumberInput
                  value={temperature}
                  min={MIN_TEMP}
                  max={MAX_TEMP}
                  step={0.01}
                  onChange={(value) => setTemperature(value)}
                  className={getClassName('output-box', location)}
                  dataCy="temperature-output-box"
                  disabled={isReadOnlyState}
                />

              </Box>
            </Form.Field>

            {/* Max Token Slider */}
            <Form.Field className={getClassName('max-token-container', location)}>
              {/* <label className={getClassName('max-token-label', location)}>Maximum Output Token</label> */}
              <Popup
               content={"The maximum number of words to generate the output."}
               inverted
               position="top left"
               style={{ borderRadius: "15px" }}
               trigger={<label className={getClassName('max-token-label', location)}>Maximum Output Token</label>}
               disabled={isReadOnlyState}
              />
              <Box className={getClassName('slider', location)}>
                <SliderComponent
                  value={Math.floor(maxTokens)}
                  min={MIN_TOKEN}
                  max={MAX_TOKEN}
                  step={1}
                  onChange={(e, newValue) => setMaxTokens(newValue)}
                  marks={[{ value: MIN_TOKEN }, { value: MAX_TOKEN }]}
                  disabled={isReadOnlyState}
                />
                <NumberInput
                  value={maxTokens}
                  min={MIN_TOKEN}
                  max={MAX_TOKEN}
                  step={1}
                  onChange={(value) => setMaxTokens(value)}
                  className={getClassName('output-box', location)}
                  dataCy="max-token-output-box"
                  disabled={isReadOnlyState}
                />

              </Box>
            </Form.Field>
          </div>
          <div className={getClassName('pair-reranker-model', location)}>
            {/* Top P Value Slider */}
            <Form.Field className={getClassName('top-p-value-container', location)}>
              {/* <label className={getClassName('top-p-value-label', location)}>Top P Value</label> */}
              <Popup
               content={"Instruct whether response should be simple or complex words."}
               inverted
               position="top left"
               style={{ borderRadius: "15px" }}
               trigger={<label className={getClassName('top-p-value-label', location)}>Top P Value</label>}
               disabled={isReadOnlyState}
              />
              <Box className={getClassName('slider', location)}>
                <SliderComponent
                  value={topPValue}
                  min={MIN_TOP_P}
                  max={MAX_TOP_P}
                  step={0.01}
                  onChange={(e, newValue) => setTopPValue(parseFloat(newValue))}
                  marks={[{ value: MIN_TOP_P }, { value: MAX_TOP_P }]}
                  disabled={isReadOnlyState}
                />

                <NumberInput
                  value={topPValue}
                  min={MIN_TOP_P}
                  max={MAX_TOP_P}
                  step={0.01}
                  onChange={(value) => setTopPValue(value)}
                  className={getClassName('output-box', location)}
                  dataCy="top-p-value-output-box"
                  disabled={isReadOnlyState}
                />

              </Box>
            </Form.Field>

            <Form.Field className={getClassName('modelname-container', location)}>
              {/* <label className={getClassName('modelname-label', location)}>Model Name:</label> */}
              <Popup
               content={"The name of the openai model being used."}
               inverted
               position="top left"
               style={{ borderRadius: "15px" }}
               trigger={<label className={getClassName('modelname-label', location)}>Model Name:</label>}
               disabled={isReadOnlyState}
              />
              <DropdownComponent
                selection
                value={modelName}
                onChange={(e, { value }) => setModelName(value)}
                options={modelsConfig.chatModels}
                className={getClassName('dropdown-input', location)}
                dataCy="model-name-input"
                icon="dropdown"
                disabled={isReadOnlyState}
              />
            </Form.Field>
          </div>

          <Form.Field className={getClassName('reranker-container', location)}>
            {/* <label className={getClassName('reranker-label', location)}>Enable Re-ranker</label> */}
            <Popup
               content={"Enable or disable the ranking of the documents. Highest ranked docs will be used to generate response."}
               inverted
               position="top left"
               style={{ borderRadius: "15px" }}
               trigger={<label className={getClassName('reranker-label', location)}>Enable Re-ranker</label>}
               disabled={isReadOnlyState}
             />
            <RadioButton
              value="yes"
              checked={isRerankerEnabled === true}
              onChange={handleRerankerChange}
              className={getClassName('radio-input', location)}
              label="Yes"
              disabled={isReadOnlyState}
            />
            <RadioButton
              value="no"
              checked={isRerankerEnabled === false}
              onChange={handleRerankerChange}
              className={getClassName('radio-input', location)}
              label="No"
              disabled={isReadOnlyState}
            />
          </Form.Field>
          <Form.Field className={getClassName('showFullPage-container', location)}>
            <Popup
              content={
                <div>
                  Select the preferred Image response format:
                  <ul>
                    <li>Just images (Only Images)</li>
                    <li>Full Pages (Entire Pages)</li>
                    <li>Don't Show images (No Images)</li>
                    <li>Thumbnails (Small Previews of Full Pages)</li>
                  </ul>
                </div>
            }
              inverted
              position="top left"
              style={{ borderRadius: "15px" }}
              trigger={<label className={getClassName('showFullPage-label', location)}>Show Images in response as</label>}
            />
            <div style={{ display: 'flex', flexDirection: 'column' }}>
            <RadioButton
              value="justImages"
              checked={showImagesOption === 'justImages'}
              onChange={handleShowImagesOption}
              className={getClassName('radio-input', location)}
              label="Just images"
              style={{ marginBottom: '10px' }}
              dataCy="radio-justImages"
              disabled={isReadOnlyState}
            />
            <RadioButton
              value="fullPages"
              checked={showImagesOption === 'fullPages'}
              onChange={handleShowImagesOption}
              className={getClassName('radio-input', location)}
              label="Full Pages"
              style={{ marginBottom: '10px' }}
              dataCy="radio-fullPages"
              disabled={isReadOnlyState}
            />
            <RadioButton
              value="dontShowImages"
              checked={showImagesOption === 'dontShowImages'}
              onChange={handleShowImagesOption}
              className={getClassName('radio-input', location)}
              label="Don't Show images"
              style={{ marginBottom: '10px' }}
              dataCy="radio-dontShowImages"
              disabled={isReadOnlyState}
            />
            <RadioButton
              value="thumbnails(fullPages)"
              checked={showImagesOption === 'thumbnails(fullPages)'}
              onChange={handleShowImagesOption}
              className={getClassName('radio-input', location)}
              label="Thumbnails (full pages)"
              style={{ marginBottom: '10px' }}
              dataCy="radio-thumbnails"
              disabled={isReadOnlyState}
            />
              </div>
          </Form.Field>

          <Form.Field className={getClassName('show-source-container', location)}>
            {/* <label className={getClassName('show-source-label', location)}>Show Source</label> */}
            <Popup
               content={"Show or hide the source documents in the response."}
               inverted
               position="top left"
               style={{ borderRadius: "15px" }}
               trigger={<label className={getClassName('show-source-label', location)}>Show Source</label>}
               disabled={isReadOnlyState}
             />
            <RadioButton
              value="yes"
              checked={showSource === true}
              onChange={handleShowSourceChange}
              className={getClassName('radio-input', location)}
              label="Yes"
              disabled={isReadOnlyState}
            />
            <RadioButton
              value="no"
              checked={showSource === false}
              onChange={handleShowSourceChange}
              className={getClassName('radio-input', location)}
              label="No"
              disabled={isReadOnlyState}
            />
          </Form.Field>

          <Form.Field className={getClassName('questionprompt-container', location)}>
            {/* <label className={getClassName('questionprompt-label', location)}>Question Generator Prompt:</label> */}
            <Popup
               content={"The prompt to guide the Bot to take the new question and past conversation and provide new rephrased question."}
               inverted
               position="top left"
               style={{ borderRadius: "15px" }}
               trigger={<label className={getClassName('questionprompt-label', location)}>Question Generator Prompt:</label>}
               disabled={isReadOnlyState}
              />
            <TextfieldComponent
              rows="7"
              className={getClassName('textfield-input', location)}
              dataCy="question-prompt-input"
              value={questionGeneratorPrompt}
              onChange={setQuestionPrompt}
              onKeyPress={(e) => {
                if (e.key === '{' || e.key === '}' || e.key === '"') {
                  e.preventDefault();
                }
              }}
              disabled={isReadOnlyState}
            />
          </Form.Field>
    
      
          <Form.Field className={getClassName('questionprompt-container', location)}>
            <div className="clarify-prompt-header">
              {/* Label for Clarify Prompt */}
              <Popup
                content="Enable or disable the clarify prompt. This prompt is used to ask clarifying questions if the user query is ambiguous."
                inverted
                position="top left"
                style={{ borderRadius: "15px", background: "black", color: "white", padding: "0.5rem" }}
                trigger={
                  <label className={getClassName('questionprompt-label', location)}>
                    Clarify Prompt:
                  </label>
                }
                disabled={isReadOnlyState}
              />

                {/* Toggle Button with Tooltip */}
                <Popup
                content={isClarifyPromptEnabled ? "Disable Clarify Prompt" : "Enable Clarify Prompt"}
                inverted
                position="top center"
                style={{ borderRadius: "15px", background: "black", color: "white", padding: "0.5rem" }}
                trigger={
                  <label className="toggle-label">
                    <input
                      type="checkbox"
                      checked={isClarifyPromptEnabled}
                      onChange={handleToggleChange}
                      className="toggle-input"
                      disabled={isReadOnlyState}
                    />
                    <span className="toggle-slider"></span>
                  </label>
                }
                disabled={isReadOnlyState}
              />
            </div>

            {/* Textfield for Clarify Prompt */}
            {/* Textfield for Clarify Prompt */}
            <textarea
                    rows="7"
                    className={getClassName('textfield-input', location)}
                    data-cy="clarify-prompt-input"
                    value={clarifyPrompt}
                    onChange={(e) => setClarifyPrompt(e.target.value)}
                    onKeyPress={(e) => {
                      if (e.key === '{' || e.key === '}' || e.key === '"') {
                        e.preventDefault();
                      }
                    }}
                    disabled={!isClarifyPromptEnabled}
                  />
          </Form.Field>

          <Form.Field className={getClassName('regenerateprompt-container', location)}>
            {/* <label className={getClassName('questionprompt-label', location)}>Q&A Regenerate Prompt:</label> */}
            <Popup
               content={"The prompt to guide the Bot to regenerate the better response with needful information."}
               inverted
               position="top left"
               style={{ borderRadius: "15px" }}
               trigger={<label className={getClassName('questionprompt-label', location)}>Q&A Regenerate Prompt:</label>}
               disabled={isReadOnlyState}
              />
            <TextfieldComponent
              rows="7"
              className={getClassName('textfield-input', location)}
              dataCy="regeneration-prompt-input"
              value={regeneratePrompt}
              onChange={setRegenerationPrompt}
              onKeyPress={(e) => {
                if (e.key === '{' || e.key === '}' || e.key === '"') {
                  e.preventDefault();
                }
              }}
              disabled={isReadOnlyState}
            />
          </Form.Field>

          <Form.Field className={getClassName('regeneratefeedbackprompt-container', location)}>
            <Popup
              content={"The prompt to guide the Bot to regenerate the response based on user feedback."}
              inverted
              position="top left"
              style={{ borderRadius: "15px" }}
              trigger={<label className={getClassName('questionprompt-label', location)}>Q&A Regenerate with Feedback Prompt:</label>}
              disabled={isReadOnlyState}
            />
            <TextfieldComponent
              rows="7"
              className={getClassName('textfield-input', location)}
              dataCy="regeneration-feedback-prompt-input"
              value={regenerateWithFeedbackPrompt}
              onChange={setRegenerationFeedbackPrompt}
              onKeyPress={(e) => {
                if (e.key === '{' || e.key === '}' || e.key === '"') {
                  e.preventDefault();
                }
              }}
              disabled={isReadOnlyState}
            />
          </Form.Field>

          <Form.Field className={getClassName('tableSchema-container', location)}>
            <Popup
              content={"Description for all the columns present in the dataset."}
              inverted
              position="top left"
              style={{ borderRadius: "15px" }}
              trigger={<label className={getClassName('tableSchema-label', location)}>Table Schema</label>}
              disabled={isReadOnlyState}
            />
            <TextfieldComponent
              rows="7"
              className={getClassName('textfield-input', location)}
              dataCy="tableSchema-input"
              value={tableSchema}
              onChange={setTableSchema}
              onKeyPress={(e) => {
                if (e.key === '{' || e.key === '}' || e.key === '"') {
                  e.preventDefault();
                }
              }}
              disabled={isReadOnlyState}
            />
          </Form.Field>

          <Button onClick={handleClear} data-cy="reset-button-cy" disabled={isReadOnlyState}
            className={getClassName('clear-button', location)}>Reset</Button>
          <Button
            onClick={handleSave}
            className="save-buttons"
            data-cy="save-button-cy"
            disabled={saveDisabled || isReadOnlyState}
          >
            Save for all users
          </Button>
        </Form>
      )}
    </div>

  );
};

export default RetrievalParameter;
